export const DELIVERY = 'DELIVERY';
export const APPOINTMENT = 'APPOINTMENT';
